class ClaroluzValueFormat {
    constructor() {
        
    }

    public static of(value: any): string {
        if (typeof value === 'number') {
            return value.toFixed(2).replace('.', ',');
        } else {
            let newValue = value.toString();
            newValue = newValue.replace(/\./g, ",");
            return newValue;
        }        
    }
}